import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { formatLedgerAmount } from './clientLedgerTypes';

export const billingYearLabel = year => `${year}/${String(year + 1).slice(-2)}`;

export default function ClientBillingSummary({ summary, year, onYear }) {
  const { t, i18n } = useTranslation();
  if (!summary) return null;
  if (summary.assignmentStatus !== 'ready') return <div role="status" className="alert alert-warning">{t('billing:yearScope.pending')}</div>;
  const money = cents => formatLedgerAmount(cents / 100, i18n.language);
  const selected = summary.years.find(item => item.schoolYearStartYear === year);
  const others = summary.years.filter(item => item.schoolYearStartYear !== year);
  return (
    <div className="card p-3 mb-3 manage-text">
      {year !== undefined && <strong>{t('billing:yearScope.balance')} {billingYearLabel(year)}: {money(selected ? selected.balanceCents : 0)}</strong>}
      {year !== undefined && <div>{t('billing:yearScope.otherDebt')}: {money(others.reduce((sum, item) => sum + Math.min(0, item.balanceCents), 0))}</div>}
      {year !== undefined && <div>{t('billing:yearScope.otherCredit')}: {money(others.reduce((sum, item) => sum + Math.max(0, item.balanceCents), 0))}</div>}
      <div>{t('billing:yearScope.overall')}: {money(summary.overallBalanceCents)}</div>
      <small>{t('billing:yearScope.noOffset')}</small>
      <div>{summary.years.map(item => (
        <button key={item.schoolYearStartYear} type="button" className="btn btn-link" onClick={() => onYear(item.schoolYearStartYear)}>
          {billingYearLabel(item.schoolYearStartYear)}: {money(item.balanceCents)}
        </button>
      ))}
      </div>
    </div>
  );
}
ClientBillingSummary.propTypes = { summary: PropTypes.object, year: PropTypes.number, onYear: PropTypes.func.isRequired };
ClientBillingSummary.defaultProps = { summary: null, year: undefined };
